<template>
  <article>
    <section class="xbed-sub-title">
      <span>门店详情</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理</BreadcrumbItem>
        <BreadcrumbItem>门店详情</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="基本信息" name="baseInfo" ref="baseInfo">
        <section>
          <Row>
            <Col span="3" class-name="text-align-right">xbed门店ID</Col>
            <Col span="8" offset="1">{{ baseInfo.xbedHotelId }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">门店名称</Col>
            <Col span="8" offset="1">{{ baseInfo.xbedHotelName }}</Col>
          </Row>
          <br>
          <!-- <Row>
            <Col span="3" class-name="text-align-right">所属热点</Col>
            <Col span="8" offset="1">{{ baseInfo.hotspot }}</Col>
          </Row> -->
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">省份</Col>
            <Col span="8" offset="1">{{ baseInfo.province }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">城市</Col>
            <Col span="8" offset="1">{{ baseInfo.city }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">区域</Col>
            <Col span="8" offset="1">{{ baseInfo.district }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">街道地址</Col>
            <Col span="20" offset="1">{{ baseInfo.address }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">门店提醒</Col>
            <Col span="20" offset="1">{{ baseInfo.reminder }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">在线状态</Col>
            <Col v-if="!editOnlineStatus" span="4" offset="1">{{ baseInfo.status == "S01"? "上线" : "下线" }}</Col>
            <Col v-else span="4" offset="1">
              <Select size="small" v-model="baseInfo.editedOnlineStatus" filterable>
                <Option value="S01">上线</Option>
                <Option value="S02">下线</Option>
              </Select>
            </Col>
            <Col span="1" offset="1">
              <Button type="primary" :loading="updateOnlineStatusLoading" size="small" @click="updateOnlineStatus">{{ editOnlineStatus ? "保存" : "更改状态" }}</Button>
            </Col>
          </Row>
          <br>
          <Row type="flex" align="middle">
            <Col span="3" class-name="text-align-right">
              <p>门店封面图</p>
              <p style="font-size: 12px;color: red;">建议尺寸：300 * 200 px</p>
            </Col>
            <Col span="12" offset="1">
              <img :src="baseInfo.coverImage" alt="" style="style:inline;width:100%">
              <Upload action="//upload.qiniup.com" name="file" :format="['jpg','jpeg','png']" :data="uploadData.form" :before-upload="beforeUpload" :on-success="uploadSuccess" :show-upload-list="false">
                <Button type="primary" icon="ios-cloud-upload-outline">上传文件</Button>
              </Upload>
            </Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-right">
              <p>门店介绍</p>
              <Button type="primary" :loading="updateHotelRemarkLoading" @click="updateHotelRemark" style="margin-top: 10px;">保存</Button>
            </Col>
            <Col span="19" offset="1">
              <tinymce :plugins="['lists']" toolbar1="numlist bullist outdent indent" ref="introductionEditor" id="introductionEditor" v-model="introduction"></tinymce>
            </Col>
          </Row>
        </section>
      </TabPane>
      <TabPane label="门店房型列表" name="roomTypeList" ref="roomTypeList">
        <section>
          <Form :model="roomTypeForm" @submit.native.prevent="preventSubmit" inline>
            <FormItem prop="keyword" label="房型名称：" :label-width="80">
              <Input type="text" v-model="roomTypeForm.keyword" placeholder="查询关键字"></Input>
            </FormItem>
            <FormItem prop="isPackaged" label="打包状态：" :label-width="80">
              <Select v-model="roomTypeForm.isPackaged" filterable>
                <Option value="S00">全部</Option>
                <Option value="1">已打包</Option>
                <Option value="0">未打包</Option>
              </Select>
            </FormItem>
            <FormItem prop="roomTypeQuery">
              <Button type="primary" @click="queryWithKeyword">查询</Button>
            </FormItem>
            <FormItem prop="addRoomType">
              <Button @click="addRoomType" type="primary">新增房型</Button>
            </FormItem>
            <FormItem prop="batchSetBufferRoomtype">
              <Button @click="showBatchSetBufferModal" type="primary">批量设置缓冲房量</Button>
            </FormItem>
          </Form>
          <Table stripe :loading="roomTypeList.loading" height="450" :columns="roomTypeColumns" :data="roomTypeList.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </section>
      </TabPane>
    </Tabs>
    <Modal v-model="modalDisplay" ref="addHotelModal" :loading="modalLoading" title="新增门店房型" @on-ok="prepareAddRoomType" ok-text="新增" cancel-text="取消">
      <Form @submit.native.prevent="preventSubmit" :label-width="80">
        <FormItem label="房型名称：" prop="modalRoomTypeName">
          <Input type="text" v-model="newRoomTypeName"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="batchSetModalDisplay" ref="batchSetModal" :loading="true"  title="批量设置缓冲房量" @on-ok="clickBatchModBufferFn" ok-text="确定" cancel-text="取消">
      <div>
        <span>快速填入：</span>
        <button type="primary" class="quickSetBufferBtn" @click="clickSetBufferFn(0)">0%</button>
        <button type="primary" class="quickSetBufferBtn" @click="clickSetBufferFn(0.1)">10%</button>
        <button type="primary" class="quickSetBufferBtn" @click="clickSetBufferFn(0.2)">20%</button>
        <button type="primary" class="quickSetBufferBtn" @click="clickSetBufferFn(0.5)">50%</button>
      </div>

      <Table style="margin-top:10px;" stripe height="450" :columns="batchBufferColumns" :data="batchBufferList.data"></Table>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
    this.xbedHotelId = Utils.getUrlParameterByName("xbedHotelId")

    this.apiHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
      'Authorization': Utils.findFromLocalStorage("Author-token"),//走阿里云需要
      // 'group': 'dev',
      // 'secret': 'c98606c16859082e3c80a2ae2493207b' // 开发环境直接走ip请求才需要加该参数
    }
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      channelId: 3,
      currTabName: "baseInfo",
      editOnlineStatus: false,
      updateOnlineStatusLoading: false,
      updateHotelRemarkLoading: false,
      modalDisplay: false,
      modalLoading: true,
      introduction: "",
      newRoomTypeName: "",
      roomTypeColumns: [
        {
          title: "ID",
          key: "roomTypeId",
          align: "center",
          width: 100,
          fixed: 'left'
        },
        {
          title: "销售状态",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            let status = params.row.status == "S01" ? "在售" : "下架"
            return h("div", {}, status);
          }
        },
        {
          title: "房型名称",
          key: "name",
          align: "center",
          width: 200
        },
        {
          title: "打包数量",
          key: "packageRoomCount",
          align: "center",
          width: 150
        },
        {
          title: "有效房量",
          key: "validRoomCount",
          align: "center",
          width: 150
        },
        {
          title: "缓冲房量",
          key: "bufferNum",
          align: "center",
          width: 150
        },
        {
          title: "信息房",
          key: "unifyInfoRoomName",
          align: "center",
          width: 150
        },
        {
          title: "取价房",
          key: "unifyPriceRoomName",
          align: "center",
          width: 150
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      if(this.$router){
                        this.$router.push({path: "/Ota/Ota/xbedChannelRoomTypeDetail", query: { roomTypeId: params.row.roomTypeId }});
                      }else{
                        window.open(`#/Ota/Ota/xbedChannelRoomTypeDetail?roomTypeId=${params.row.roomTypeId}`);
                      }
                    }
                  }
                },
                "编辑打包"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        render: modalH => {
                          let modalText = `确定删除 ${ params.row.roomTypeId } - ${ params.row.name } 吗？\n已打包的房间将重新单独售卖`;
                          return modalH("div", {
                            style: {
                              fontSize: "16px",
                            },
                          }, modalText)
                        },
                        onOk: () => {
                          this.removeRoomType(params.index);
                        }
                      })
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      roomTypeForm: {
        keyword: "",
        isPackaged: "S00"
      },
      baseInfo:{
        xbedHotelId: "",
        xbedHotelName: "",
        hotspot: "",
        province: "",
        city: "",
        district: "",
        address: "",
        reminder: "",
        status: "",
        coverImage: "",
        introduction: "",
        remark: "",
        editedOnlineStatus: "S01",
      },  // 基本信息
      roomTypeList:{
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      },  //房型列表
      batchSetModalDisplay: false,
      batchModalLoading: true,
      batchBufferList: {
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      },
      batchBufferColumns:[
        {
          title: "房型名称",
          key: "name",
          align: "center",
          width: 150
        },
        {
          title: "打包数量",
          key: "packageRoomCount",
          align: "center",
          width: 150
        },
        {
          title: "缓冲房量",
          key: "bufferNum",
          align: "center",
          width: 150,
          render: ( h, params ) => {
            return h( "Input", 
                {
                  props: {
										value: params.row.bufferNum,
                    type: "number"
									},
                  on: {
                    'on-change': (event)=>{
                      params.row.bufferNum = event.target.value;
                      this.batchBufferList.data[params.index].bufferNum = event.target.value
                    }
                  }
                },
            )
          }
        },
      ],
      uploadData: {
        name: "",
        form: {}
      },
      roomBufferList: []
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryHotelData();
    },
    queryHotelData() {
      if (this.currTabName == "baseInfo") {
        this.queryHotelBaseInfo();
      } else if (this.currTabName == "roomTypeList") {
        this.queryHotelRoomTypeList();
      }
    },
    changePage(pageIndex) {
      this.roomTypeList.page = pageIndex;
      this.queryHotelRoomTypeList();
    },
    changePageSize(pageSize) {
      this.roomTypeList.page = 1;
      this.roomTypeList.pageSize = pageSize;
      this.queryHotelRoomTypeList();
    },
    async queryHotelBaseInfo(){
      let resp = (await this.findHotel(
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.introduction = resp.introduction || "";
      Object.assign(this.baseInfo, resp);
      this.baseInfo.editedOnlineStatus = resp.status;

      this.introduction = this.baseInfo.introduction;
      this.$refs.introductionEditor.setContent(resp.introduction);
    },
    findHotel(token, env) {
      return API.omsAPI[env].ota.findHotel(
        this.hotelId,
        token
      );
    },
    async queryHotelRoomTypeList(){
      this.roomTypeList.loading = true;
      // const resp = (await this.getRoomTypeList(
      //   this.roomTypeList,
      //   this.token,
      //   this.env
      // )).data;
      const resp = (await this.getRoomTypeListWithBuffer(this.roomTypeList, this.env)).data
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.result.forEach( roomTypeItem => {
        roomTypeItem.packageRoomCount >= 0 ? "" : roomTypeItem.packageRoomCount = 0;
        roomTypeItem.validRoomCount >= 0 ? "" : roomTypeItem.validRoomCount = 0;
      });
      this.roomTypeList.data = resp.result;
      // this.roomTypeList.page = resp.page;
      // this.roomTypeList.pageSize = resp.pageSize;
      // this.roomTypeList.pageCount = resp.pageCount;
      this.roomTypeList.count = resp.count;
      this.roomTypeList.loading = false;
      // this.getRoomtypeBufferListFn()
    },

    refreshBatchBufferNumFn() {
      this.batchBufferList.data = []
      this.roomTypeList.data.forEach( roomTypeItem => {
        this.batchBufferList.data.push(
          {
            roomTypeId: roomTypeItem.roomTypeId,
            xbedHotelId: roomTypeItem.xbedHotelId,
            name: roomTypeItem.name,
            packageRoomCount: roomTypeItem.packageRoomCount,
            bufferNum: roomTypeItem.bufferNum
          }
        )
      });
    },
    // getRoomTypeList(roomTypeList, token, env) {
    //   let isPackaged = this.roomTypeForm.isPackaged=="S00" ? "" : this.roomTypeForm.isPackaged;
    //   let params = {
    //     channelHotelId: this.hotelId,
    //     page: roomTypeList.page,
    //     rows: roomTypeList.pageSize,
    //     status: isPackaged,
    //     name: this.roomTypeForm.keyword,
    //   }
    //   return API.omsAPI[env].ota.getRoomTypeList(params, token);
    // },
    getRoomTypeListWithBuffer (roomTypeList, env) {
      let isPackaged = this.roomTypeForm.isPackaged=="S00" ? "" : this.roomTypeForm.isPackaged;
      let params = {
        page: roomTypeList.page,
        rows: roomTypeList.pageSize,
        channelHotelId: this.hotelId,
        xbedHotelId: this.xbedHotelId,
        isPage: false,
        status: isPackaged,
        name: this.roomTypeForm.keyword,
      }
      return API.omsAPI[env].clientServer.getRoomTypeListWithBuffer(params, this.apiHeaders);
    },
    queryWithKeyword(){
      this.roomTypeList.page = 1;
      this.queryHotelRoomTypeList();
    },
    async updateOnlineStatus() {
      if (!this.editOnlineStatus) {
        this.editOnlineStatus = true;
        return;
      }
      if (!this.checkHotelData()) {
        return;
      }
      this.updateOnlineStatusLoading = true;
      let params = {
        channelHotelId: this.hotelId,
        coverImage: this.baseInfo.coverImage || "",
        status: this.baseInfo.editedOnlineStatus
      }
      let resp = (await API.omsAPI[this.env].ota.updateHotel(params, this.token)).data;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "编辑失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "编辑成功"
        });
        this.baseInfo.status = this.baseInfo.editedOnlineStatus;
        this.editOnlineStatus = false;
      }
      this.updateOnlineStatusLoading = false;
    },
    async updateHotelRemark() {
      this.updateHotelRemarkLoading = true;
      if (this.$refs.introductionEditor.getEditorInnerText().length > 5000) {
        this.$Notice.error({
          title: "编辑失败",
          desc: "门店介绍不能超过5000字"
        });
        this.updateHotelRemarkLoading = false;
        return; 
      }
      let params = {
        channelHotelId: this.hotelId,
        introduction: this.introduction || ""
      }
      let resp = (await API.omsAPI[this.env].ota.updateHotelIntro(params, this.token)).data;

      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "编辑失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "编辑成功"
        });
        this.baseInfo.introduction = this.introduction;
      }
      this.updateHotelRemarkLoading = false;
    },
    checkHotelData() {
      let msg = '';
      let isChecked = true;
      let isOnlineState = this.baseInfo.editedOnlineStatus == "S01";
      let remark = this.baseInfo.introduction;
      if (isOnlineState && !remark) {
        msg = '门店介绍不能为空';
        isChecked = false;
      } else if (isOnlineState && remark && this.$refs.introductionEditor.getEditorInnerText().length > 5000) {
        msg = '门店介绍不能超过5000字';
        isChecked = false;
      } else if (isOnlineState && !this.baseInfo.coverImage) {
        msg = '封面图不能为空';
        isChecked = false;
      } 
      if (!isChecked) {
        this.$Notice.error({
          title: "编辑失败",
          desc: msg
        });
      }
      return isChecked;
    },
    addRoomType() {
      this.modalDisplay = true;
    },
    // 添加房型
    async prepareAddRoomType() {
      if (this.newRoomTypeName.length==0) {
        this.$Notice.error({
          title: "添加房型失败",
          desc: "房型名称不能为空！"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      } else if (this.newRoomTypeName.length>50) {
        this.$Notice.error({
          title: "添加房型失败",
          desc: "房型名称不能超过50字！"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      let resp = (await API.omsAPI[this.env].ota.addRoomType(
        this.channelId,
        this.hotelId,
        this.newRoomTypeName,
        this.username,
        this.token
      )).data;

      if (resp.retCode) {
        // 错误警告
        this.$refs.addHotelModal.buttonLoading = false;
        this.$Notice.error({
          title: "添加房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "添加房型成功"
        });
        this.modalDisplay = false;
        this.refreshTable();
        this.resetAddModalData();
        this.initRoomtypeBufferNumFn(resp.channelRoomTypeId);
      }
    },
    //初始化房型缓房数量
    async initRoomtypeBufferNumFn (roomTypeId) {
      let params = {
        roomTypeId: roomTypeId,
        hotelId: this.xbedHotelId,
        bufferNum: 0,
        operater: this.username
      }
      await API.omsAPI[this.env].clientServer.modifyRoomtypeBuffer(params, this.apiHeaders)
    },
    // 删除房型
    async removeRoomType(index) {
      let roomType = this.roomTypeList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomType(
        this.channelId,
        this.username,
        roomType.roomTypeId,
        roomType.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除房型成功"
        });

        this.roomTypeList.data.splice(index, 1);
        this.queryHotelRoomTypeList();
      }
    },
    resetAddModalData() {
      this.newRoomTypeName = "";
    },
    resetAllData() {
      this.baseInfo = {
        xbedHotelId: "",
        xbedHotelName: "",
        hotspot: "",
        province: "",
        city: "",
        district: "",
        address: "",
        reminder: "",
        status: "",
        coverImage: "",
        introduction: "",
        remark: "",
        editedOnlineStatus: "S01",
      };
      this.roomTypeList = {
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      };
    },
    refreshTable() {
      this.resetAllData();
      this.queryHotelData();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
    // 图片上传前
    async beforeUpload(file) {
      console.info(`${file}`);
      let token = (await API.omsAPI[this.env].common.getUploadToken(false, this.token)).data;
      if (token.status==false) {
      this.$Notice.error({
        title: token.msg
      });
      }
      this.uploadData.form.token = token;
      this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
      this.uploadData.form["x:fileDirId"] = 636;
      this.uploadData.form["x:isPrivate"] = 0;
      this.uploadData.form["x:remark"] = "门店封面图";
      return true;
    },
    async uploadSuccess(result) {
      this.baseInfo.coverImage = result.materialBase.url;
      let params = {
        channelHotelId: this.hotelId,
        coverImage: this.baseInfo.coverImage || "",
        status: this.baseInfo.editedOnlineStatus
      }
      let resp = (await API.omsAPI[this.env].ota.updateHotel(params, this.token)).data;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "图片更换失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "图片更换成功"
        });
      }
    },
    // async getRoomtypeBufferListFn() {
    //   try {
    //     let params = {
    //       hotelId: this.hotelId
    //     }
    //     let res = (await API.omsAPI[this.env].clientServer.getRoomtypeBufferList(params, this.apiHeaders)).data
    //     if (res.retCode) {
    //       this.$Notice.error({
    //         desc: res.msg
    //       });
    //     } else {
    //       this.roomBufferList = res;
    //       this.dueRoomtypelistBySetBufferNumFn()
    //     }
    //   } catch (error) {
    //     console.info(error);
    //   }
    // },
    // dueRoomtypelistBySetBufferNumFn() {
    //   let roomTypeListData = Object.assign([], this.roomTypeList.data)
    //   roomTypeListData.forEach(item => {
    //     item.bufferNum = 0
    //     for(let a=0; a<this.roomBufferList.length; a++) {
    //       if (item.roomTypeId == this.roomBufferList[a].roomTypeId) {
    //         item.bufferNum = this.roomBufferList[a].bufferNum
    //         break
    //       }
    //     }
    //   });
    //   this.roomTypeList.data = roomTypeListData

    //   let batchBufferListData = Object.assign([], this.batchBufferList.data)
    //   batchBufferListData.forEach(item => {
    //     item.bufferNum = 0
    //     for(let a=0; a<this.roomBufferList.length; a++) {
    //       if (item.roomTypeId == this.roomBufferList[a].roomTypeId) {
    //         item.bufferNum = this.roomBufferList[a].bufferNum
    //         break
    //       }
    //     }
    //   });
    //   this.batchBufferList.data = batchBufferListData
    // },
    clickSetBufferFn(percent) {
      let batchBufferListData = this.batchBufferList.data
      batchBufferListData.forEach(item => { 
          item.bufferNum = parseInt(Math.round(item.packageRoomCount * percent))
      });
      this.batchBufferList.data = batchBufferListData
    },
    beforeBatchModBufferFn() {
      let isAvail = true
      for (let a = 0; a < this.batchBufferList.data.length; a++) {
        let batchBufferItem = this.batchBufferList.data[a]
        if (batchBufferItem.bufferNum == null || (batchBufferItem.bufferNum + '').trim()== "") {
          isAvail = false
          this.$Notice.error({
            title: "缓冲房量不能为空！",
          });
          this.$refs.batchSetModal.buttonLoading = false;
          break
        } else if (batchBufferItem.bufferNum > batchBufferItem.packageRoomCount) {
          isAvail = false
          this.$Notice.error({
            title: "缓冲房量不能大于打包数量！",
          });
          this.$refs.batchSetModal.buttonLoading = false;
          break
        }
      }
      return isAvail
    },
    clickBatchModBufferFn() {
      if (!Utils.hasPermission('oms_ota_dailyInventory_updateBufferCount')) {
        this.$Notice.error({
          title: '无权限操作'
        })
        return
      }
      this.doRequestBatchModBufferFn()
    },
    async doRequestBatchModBufferFn(){
      if (!this.beforeBatchModBufferFn()) {
        return
      }
      
      try {
        let roomTypeBufferList = []
        this.batchBufferList.data.forEach(roomTypeItem => {
          roomTypeBufferList.push(
            {
              roomTypeId: roomTypeItem.roomTypeId,
              hotelId: roomTypeItem.xbedHotelId,
              bufferNum: roomTypeItem.bufferNum,
              operater: this.username
            }
          )
        });

        let params = {
          roomTypeBufferList: roomTypeBufferList
        }

        let myheaders = this.apiHeaders
        myheaders.isForm = true
        let res = (await API.omsAPI[this.env].clientServer.batchModBuffer(params, myheaders )).data
        if (res.retCode) {
          this.$Notice.error({
            desc: res.msg
          });
        } else {
          this.$Notice.success({
            title: "批量设置缓冲房量成功"
          });
          this.queryHotelRoomTypeList()
        }
        this.$refs.batchSetModal.buttonLoading = false;
        this.batchSetModalDisplay = false
      } catch (error) {
        console.info(error);
      }
    },
    showBatchSetBufferModal() {
      this.refreshBatchBufferNumFn()
      this.batchSetModalDisplay = true
    },
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.text-align-right {
  text-align: right;
}

.quickSetBufferBtn {
  margin-right: 10px;
  width: 60px;
  height: 26px;
  color: blue;
  background: white;
}

</style>



// WEBPACK FOOTER //
// src/pages/ota/hotel-detail.vue